import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/account")({
  head: () => ({
    meta: [
      { title: "Your Pal Stars Account — Sync Favorites, Decks & Tracker" },
      { name: "description", content: "Manage your Pal Stars account and sync Palworld favorites, deck builds and TCG pack tracker across all your devices." },
      { property: "og:title", content: "Your Pal Stars Account" },
      { property: "og:description", content: "Sync favorites, decks and pack tracker across devices." },
      { property: "og:url", content: "https://palstars.com/account" },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "robots", content: "noindex,follow" },
    ],
    links: [{ rel: "canonical", href: "https://palstars.com/account" }],
  }),
});
